<div class="mb-4 border p-4 bg-white shadow-sm">
  <div class="mb-1">
    <form [formGroup]="form"
          class="d-flex flex-row align-items-end gap-2">
      @if (editMode()) {
        <textarea class="form-control"
                  id="content"
                  formControlName="content"
                  rows="2"
                  placeholder="Add a note"></textarea>
        <button class="btn btn-primary"
                (click)="addNote()">Add</button>
      }
    </form>

    @if (!editMode()) {
      <span id="content">{{ note()?.content }}</span>

      <button class="btn btn-outline-primary border-0 float-end"
              (click)="deleteNote()">
        <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
      </button>
    }
  </div>
  @if (note()?.author || note()?.updatedAt) {
    <small id="title"
           class="text-muted float-end">{{ note()?.author }} noted on {{ note()?.updatedAt | date: 'medium' }}</small>
  }
</div>